import {
    AnySheet,
    IAnySheetSnapshot,
    SheetColumnName,
    SheetName
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {Workbook} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/Workbook';
import {SheetId, WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {createTransformer, ITransformer} from 'mobx-utils';
import {DesignStateFromJsonCtx} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';

export interface ICloudSheetSnapshot extends IAnySheetSnapshot
{
}

export class CloudSheet extends AnySheet
{
    private constructor()
    {
        super();
    }

    public static create(id:SheetId,
                         workbook:Workbook,
                         name:SheetName,
                         columnNames:Array<SheetColumnName> = []):CloudSheet
    {
        const cloudSheet:CloudSheet = new CloudSheet();

        cloudSheet.id = id;
        cloudSheet.workbook = workbook;
        cloudSheet.name = name;
        cloudSheet.columnNames = columnNames;

        return cloudSheet;
    }

    public clone():CloudSheet
    {
        // todo: duplicate cloud slots

        const cloudSheet:CloudSheet = new CloudSheet();

        cloudSheet.id = IdUtil.newGUID();
        cloudSheet.workbook = this.workbook;
        cloudSheet.name = this.name;
        cloudSheet.columnNames = this.columnNames;

        return cloudSheet;
    }

    public get isCloud():boolean
    {
        return true;
    }

    public static toJson:ITransformer<CloudSheet, ICloudSheetSnapshot> = createTransformer((cloudSheet:CloudSheet) =>
    {
        return {
            id: cloudSheet.id,
            name: cloudSheet.name,
            columnNames: cloudSheet.columnNames
        };
    });

    public static fromJson(json:ICloudSheetSnapshot,
                           workbook:Workbook,
                           currentState?:CloudSheet,
                           currentJson?:ICloudSheetSnapshot,
                           ctx?:DesignStateFromJsonCtx):CloudSheet
    {
        return CloudSheet.fromJsonDeep(json, workbook);
    }

    public static fromJsonDeep(json:ICloudSheetSnapshot, workbook:Workbook):CloudSheet
    {
        const cloudSheet:CloudSheet = new CloudSheet();

        cloudSheet.id = json.id;
        cloudSheet.workbook = workbook;
        cloudSheet.name = json.name;
        cloudSheet.columnNames = json.columnNames;

        return cloudSheet;
    }
}
